import React from "react";
import StyledInputAdornment from "./InputAdornment.styled";
import { InputAdornmentProps as MuiInputAdornmentProps } from "@mui/material/InputAdornment";

interface InputAdornmentProps extends MuiInputAdornmentProps {
  value?: string;
  disabled?: boolean;
}

export default function InputAdornment({
  children,
  position = "start",
  value,
  disabled,
  ...props
}: InputAdornmentProps) {
  return (
    <StyledInputAdornment
      position={position}
      value={value}
      disabled={disabled}
      {...props}
    >
      {children}
    </StyledInputAdornment>
  );
}
